import Label from './Label';
import ErrorMessage from './ErrorMessage';

const CardField = ({ field, label }) => (
  <div className="flex w-full flex-col gap-1">
    <Label htmlFor={field} required>
      {label}
    </Label>
    <div className={`payment-input-wrapper ${field}-wrapper`}>
      <div className={`${field} w-full`} id={field}></div>
    </div>
    <ErrorMessage className={`${field}-error`} />
  </div>
);

export default CardField;
